import React from 'react';
import './home.css'
import '../../App.css'
import Sec4ArrowSvg from '../../svgs/home/Sec4ArrowSvg.js'
import InViewComponent from '../../screens/components/InView.js';
import CONTENT from '../../contents/home.js'
import BTN from '../../contents/btn.js'
import { useLang } from '../../hook/UseLang.js';
import { useNavigate } from 'react-router-dom';
const Home2 = () => {
    const text1Ref = React.useRef(null);
    const text2Ref = React.useRef(null);
    const [lang, setLang] = useLang();
    const navigate = useNavigate()
    return (
        <div className='w-full min-h-[97vh] relative' style={{letterSpacing : .2}}>
            <img src='./images/bg_texture.jpg' className='absolute top-0 left-0 w-full h-full' style={{objectFit: 'cover', zIndex:1}}></img>
            <div className='relative w-full h-full flex flex-row items-center justify-center' style={{zIndex:2}}>
                <div className='w-full h-[60%] border flex flex-row-col items-center justify-center'>
                    <div className='flex relative w-full' style={{flex:1.5, height:'100%'}}>
                        <div className='bg-white opacity-[0.7] w-full h-full absolute' style={{zIndex:1}}></div>
                        <div className='relative flex flex-col items-center justify-center w-full h-full py-[12px]' style={{zIndex:2}}>
                            <div className='w-[90%] max-w-[369px] min-h-[311px] flex flex-col justify-between items-start-center two-k-gap-6'>
                                <div ref={text1Ref} className='text-homesec-title playfair-display title_text' style={{letterSpacing:5}}>{CONTENT.sec4_0[lang]}</div>
                                <InViewComponent reffing={text1Ref} active='title_text_active' />
                                <div ref={text2Ref} className='title_text'>
                                    <div className='text-d-12 mb-[24px]'>
                                    {CONTENT.sec4_1[lang]}
                                    </div>
                                    <div className='text-d-12'>
                                    {CONTENT.sec4_2[lang]}
                                    </div>
                                </div>
                                <InViewComponent reffing={text2Ref} active='title_text_active' />      
                                <div onClick={() => navigate(`./facility?lang=${lang}`)} className='text-d-12 flex flex-row items-center justify-center w-[90%] max-w-[208px] py-[12px] border border-[#0FBAB5] text-[#0FBAB5] relative select-none cursor-pointer hover:bg-[#0FBAB5] hover:text-white transition-all duration-300 btn-arrow'>
                                    <div className=''>{BTN.view_more[lang]}</div>
                                    <div className='absolute right-[-16%] top-[46%] arrow-moveleft'>
                                        <Sec4ArrowSvg/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='flex border relative' style={{flex:2, height:'100%'}}>
                        <img src='./images/home/sec4_1.png' className='w-full h-full' style={{objectFit:'cover'}}></img>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home2;